// extracted by mini-css-extract-plugin
export default {"buttons":"ServicesDeactivateModal_buttons__25uY7","errorMessage":"ServicesDeactivateModal_errorMessage__2RrX7"};